<template>
    <v-dialog
    v-model="shown"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Dodaj opombo
      </v-card-title>

      <v-card-text>
        <form @submit.prevent="save">
          <v-row>
            <v-col>
              <v-text-field label="Opomba" v-model="comment"></v-text-field>
            </v-col>
          </v-row>
          <div style="height: 30px; margin-top: 20px;">
            <v-btn text type="button" class="float-right mr-4" style="color: white; background: green;" @click="save">Shrani</v-btn>
            <v-btn text type="button" class="float-right mr-4" style="color: white; background: red;" @click="close('empty')">odstrani</v-btn>
          </div>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    comment: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      shown: false
    }
  },
  methods: {
    close (empty) {
      if (empty) this.$emit('commentAdd', '')
      this.shown = false
    },
    save () {
      this.$emit('commentAdd', this.comment)
      this.close()
    },
    open () {
      this.shown = true
    }
  }
}
</script>
